export default __webpack_public_path__ + "static/media/moon.bbad5114.svg";